import {
  DataTableAction,
  EllipsisMenuButton,
  Menu,
  MenuContent,
  MenuTrigger,
} from '@optiaxiom/react';

import type { NotificationRow } from '../../../types';

type ActionsCellProps = {
  notification: NotificationRow;
  isGroup?: boolean;
  onMarkRead: () => void;
  onMarkUnread: () => void;
  onDelete: () => void;
};

export function ActionsCell({
  notification,
  isGroup,
  onMarkRead,
  onMarkUnread,
  onDelete,
}: ActionsCellProps) {
  const options = isGroup
    ? [
        { label: 'Mark all as read', execute: onMarkRead },
        { label: 'Dismiss all', intent: 'danger' as const, execute: onDelete },
      ]
    : [
        notification.is_read
          ? { label: 'Mark as unread', execute: onMarkUnread }
          : { label: 'Mark as read', execute: onMarkRead },
        { label: 'Dismiss', intent: 'danger' as const, execute: onDelete },
      ];

  return (
    <Menu options={options}>
      <DataTableAction asChild visible="always">
        <MenuTrigger asChild>
          <EllipsisMenuButton appearance="subtle" aria-label="Options" />
        </MenuTrigger>
      </DataTableAction>
      <MenuContent />
    </Menu>
  );
}
